import { faAngleLeft, faAngleRight } from '@fortawesome/pro-solid-svg-icons';

import { Component, Input, Output } from 'angular-ts-decorators';

import { SwChange } from '@core/app/scripts/classes/sw-change';

/**
 * Allow for picking a date. Attributes:
 * * set the date form the outside
 * * sw-change - callback that is has newly set data availabe as `date`
 * * placeholder - string to be displayed when value is not set
 * ## Example
 * <code><pre>
 *   <sw-date-picker
 *     date="dateVariable"
 *     sw-change="test(date)"></sw-date-picker>
 * </pre></code>
 */

@Component({
  selector: 'swDatePicker',
  template: require('./sw-date-picker.html').default,
})
export class SwDatePickerComponent extends SwChange {
  @Input() date: Date;
  @Input() minDate: Date;
  @Input() maxDate: Date;
  @Input('@') placeholder: string;

  @Output() swChange: (any) => any;

  faAngleLeft = faAngleLeft;
  faAngleRight = faAngleRight;

  constructor(
    public timeZone,
    private moment,
  ) {
    'ngInject';

    super();
  }

  changeDay(direction: string): void {
    if (direction === 'add' || direction === 'subtract') {
      const momentDate = this.moment(this.date);
      this.date = momentDate[direction](1, 'day').toDate();
      this.change(this.date);
    }
  }
}
